import { Theme, makeStyles } from '@focaldata/cin-ui-components'
import {
  ACCORDION_QUESTION_TYPES_WIDTH,
  ACCORDION_SUMMARY_WIDTH,
  EDIT_TARGETING_FIXED_CONTENT_HEIGHT
} from '../constants'

interface StyleProps {
  isWindowResized?: boolean
  height?: string
}

const useStyles = makeStyles<{ styleProps?: StyleProps }>()(
  (theme: Theme, { styleProps: props }) => ({
    cardListOuter: {
      width: props?.isWindowResized
        ? `calc(100% - ${ACCORDION_QUESTION_TYPES_WIDTH}px)`
        : `calc(100% - ${ACCORDION_QUESTION_TYPES_WIDTH}px - ${ACCORDION_SUMMARY_WIDTH}px)`,
      overflowY: 'auto',
      height:
        props?.height ??
        `calc(100vh - ${EDIT_TARGETING_FIXED_CONTENT_HEIGHT}px)`
    },
    cardList: {
      width: '100%',
      minWidth: '660px',
      position: 'relative',
      height: '100%',
      overflow: 'auto'
    },
    // Sized to the button and kept left, clear of the floating Market settings
    // gear in the editor's top-right corner.
    toolbar: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      width: 'fit-content',
      padding: theme.spacing(0.5, 1, 0.5, 0),
      backgroundColor: theme.palette.background.paper
    },
    emptyStateContainer: {
      paddingTop: theme.spacing(8)
    },
    emptyStateIcon: {
      paddingBottom: theme.spacing(1)
    },
    emptayStateText: {
      width: 520
    }
  })
)

export default useStyles
